import { NgIf } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';
import {
  Notification,
  NotificationComponent
} from '@com-delta-idp/mnx-skymiles-shared';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import {
  MedallionBannerComponent,
  SkeletonLoaderDirective
} from '@com-delta-omnichannel/aura';
import { MenuComponent } from '../../features';
import { LandingPage } from './models/landing-page.interfaces';

@Component({
  imports: [
    MenuComponent,
    SkeletonLoaderDirective,
    MedallionBannerComponent,
    NotificationComponent,
    NgIf
  ],
  selector: 'idp-landing-page-ui',
  standalone: true,
  styleUrls: ['./landing-page.component.scss'],
  templateUrl: './landing-page.component.html'
})
export class LandingPageComponent implements AfterViewInit {
  @Input() content: LandingPage = {} as LandingPage;
  @Input() notification: Notification | null = null;

  constructor(private analytics: AnalyticsService) {}

  ngAfterViewInit(): void {
    this.triggerAnalyticsEvent();
  }

  triggerAnalyticsEvent() {
    const analytic = this.content.medallionBanner.analyticsEvent;
    if (analytic && analytic.name && analytic.value) {
      this.analytics.dispatchCustomEvent<string>(analytic.name, analytic.value);
    }
  }

  redirect(link: string, type = '_self') {
    window.open(link, type);
  }
}
